import { render, staticRenderFns } from "./TwToTop.vue?vue&type=template&id=9628fa04&scoped=true&"
import script from "./TwToTop.vue?vue&type=script&lang=js&"
export * from "./TwToTop.vue?vue&type=script&lang=js&"
import style0 from "./TwToTop.vue?vue&type=style&index=0&id=9628fa04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9628fa04",
  null
  
)

export default component.exports